import { Component, OnInit } from '@angular/core';
import { CmsComponentData } from "@spartacus/storefront";
import { CustomDoubleBannerModel } from "../custom-double-banner/custom-double-banner.model";
import { CmsService } from "@spartacus/core";
import { map, switchMap } from "rxjs/operators";
import { combineLatest, Observable } from "rxjs";
import { CustomReverseBannerModel } from "./custom-reverse-banner.model";

@Component({
  selector: 'app-custom-reverse-banner',
  templateUrl: './custom-reverse-banner.component.html',
  styleUrls: ['./custom-reverse-banner.component.scss'],
  standalone: false
})
export class CustomReverseBannerComponent implements OnInit {

  constructor(
    private componentData: CmsComponentData<CustomReverseBannerModel>,
    private cmsService: CmsService
  ) {
  }

  data$ = this.componentData.data$.pipe(map(component => component));
  items$: Observable<any[]> = this.componentData.data$.pipe(
    switchMap(data =>
      combineLatest(
        data.items.trim().split(' ').map((codes: any) => this.cmsService.getComponentData(codes).pipe(
          map(tab => tab)
        )))
    ));

  ngOnInit(): void {
  }

}
